import React, { useState, useEffect, useContext } from 'react'
import { Button, Col, Statistic, Typography } from 'antd'

import { CourseContext } from '../Course/CourseContext'
import { Course } from '../Course/types'
import { FlexRow } from '../FlexboxReusables/FlexItems'
import axios, { AxiosResponse } from 'axios'
import { apiUrl } from '../../globals'
import { ExamStatisticsResponse } from './types'

const StatisticsOverview: React.FC = () => {
  const { courseContext } = useContext(CourseContext)

  const [ numberOfPublishedCourses, setNumberOfPublishedCourses ] = useState<number>()

  useEffect(() => {
    setNumberOfPublishedCourses(courseContext.courses.filter((course) => course.isPublished).length)
  }, [ courseContext ])

  const getStatisticsForCourse = async (courseId: Course['id']) => {
    axios.get(`${apiUrl}/exam-statistics/${courseId}`)
      .then((res: AxiosResponse<ExamStatisticsResponse>) => {
        console.log(res.data)
      })
  }

  return (
    <>
      <FlexRow>
        <Typography.Title level={2}>Statistiken</Typography.Title>
      </FlexRow>
      <FlexRow>
        <Col span={8}>
          <Statistic
            title="Veröffentlichte Schulungen"
            value={numberOfPublishedCourses}
            valueStyle={{ border: '2px solid red' }}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Kursteilnehmer"
            value={112893}
            valueStyle={{ border: '2px solid red' }}
          />
          <Button onClick={() => getStatisticsForCourse(278)}>Test</Button>
        </Col>
      </FlexRow>
    </>
  )
}

export default StatisticsOverview